<script lang="ts">
	import __ from '$lib/stores/TranslationStore';
	import TaxCard from '../TaxCard.svelte';
	export let installmentValues: InstallmentValues;
	export let className: string = '';
	export { className as class };

	type InstallmmentTypes = 'monthly' | 'quarterly' | 'semi_annual';

	type InstallmentValues = { [key in InstallmmentTypes]: number | null };

	const bottomTexts: { [key in InstallmmentTypes]: string } = {
		monthly: $__('Mensal'),
		quarterly: $__('Trimestral'),
		semi_annual: $__('Semestral')
	};

	// get the type name and value of the first installment type that has a value
	const installmentType = Object.entries(installmentValues).find(([name, value]) => value !== null);
	const installmentName = installmentType?.[0];
	const installmentValue = installmentType?.[1] || 0;

	const bottomText = bottomTexts[installmentName as InstallmmentTypes] || $__('Mensal');
</script>

{#if installmentName && installmentValue > 0}
	<TaxCard
		{bottomText}
		class={className}
		amount={installmentValue}
		title={$__('Seguro vida')}
		caption={$__('Habitação')}
	/>
{/if}
